import {Area, Doughnut, Donut, Gauge, Progress} from './components';

export default {
    Area,
    Doughnut,
    Donut,
    Progress,
    Gauge
};
